import { useState } from "react";
import CustomTableMaterial from "../../shared/table/customTableMaterial";
import { THomeworkType, TTableColumn } from "../../types";
import {
  ColoredStyleF,
  DisplayWithPicture,
  ReduceDisplayF,
} from "../../displayColumnsConfig";
import { RowsPerPageEnum } from "../../displayColumnsConfig";
import { useAuthContext } from "../../context/authContext";
import { isAdmin, isDataOp, isTeacher } from "../../helpers/role";

function HomeworkTable(props: { tableData: THomeworkType[] }) {
  const [page] = useState(0);
  const [rowsPerPage] = useState(RowsPerPageEnum.ALL);
  const { isAuth, authInfo } = useAuthContext();

  const homeworkColumns: TTableColumn[] = [
    {
      id: "order_task",
      label: "№ задачи",
      minWidth: 10,
      maxWidth: 60,
      align: "right",
      stylef: (s: string, row?: any) => {
        if (!row["order_task"].includes(".")) {
          return { fontWeight: "normal" };
        } else {
          return { fontStyle: "italic" };
        }
      },
    },
    {
      id: "task_id",
      label: "Код задачи",
      minWidth: 30,
      maxWidth: 60,
      align: "right",
      linkTo:
        isAdmin(authInfo.role) || isDataOp(authInfo.role)
          ? "/admin/task/edit/"
          : "/task/view/",
    },
    {
      id: "success",
      label: "Результат (попыток)",
      minWidth: 135,
      maxWidth: 135,
      align: "left",
      stylef: ColoredStyleF,
      format: (v: string, row: any) => {
        return (
          <span>
            {row.success} {row.answer_count ? `(${row.answer_count})` : ""}
          </span>
        );
      },
    },

    {
      id: "user_answers",
      label: "Ответы",
      minWidth: 300,
      maxWidth: 300,
      align: "left",
    },

    {
      id: "minimath_answer",
      label: "Ответ",
      minWidth: 100,
      maxWidth: 100,
      align: "left",
    },
    {
      id: "question",
      label: "Текст задачи",
      minWidth: 50,
      maxWidth: 100,
      align: "left",
      stylef: (s: string, row?: any) => {
        if (!row["order_task"].includes(".")) {
          return { fontWeight: "normal", width: "50%" };
        } else {
          return { paddingLeft: "3em", fontStyle: "italic" };
        }
      },
      expandable: true,
      format: ReduceDisplayF,
      expandedFormat: DisplayWithPicture,
    },
  ];

  if (isAuth && !isAdmin(authInfo.role) && !isTeacher(authInfo.role)) {
    // remove links for not admins
    homeworkColumns.forEach((e) => {
      if (e.id == "task_id") {
        e.linkTo = undefined;
      }
    });
  }

  return (
    <CustomTableMaterial<THomeworkType>
      list={props.tableData || []}
      page={page}
      columns={homeworkColumns}
      groupBy="course_site_name"
      // groupTitle={(row) => row["course_site_name"]}
      rowsPerPage={rowsPerPage}
      localPagination={true}
      groupTitle={(row) =>
        `<a href="/course/${row["course_id"]}">Курс ${row["course_id"]} "${row["course_site_name"]}"</a>`
      }
    />
  );
}

export default HomeworkTable;
